module.exports = __webpack_public_path__ + "static/media/likun.030f453b.jpg";